import ColorPaletteBase from './ColorPaletteBase.js';

export default class ColorPalette extends ColorPaletteBase {
  constructor(colorManager, onDblClickColor) {
    super(colorManager, '#colorPalette');
    this._onDblClickColor = onDblClickColor;
    //this._elAdd = this._elPalette.querySelector('.add');
    //this._elAddInner = this._elPalette.querySelector('.add .inner');

    this._elDelete = this._elPalette.querySelector('.delete');
    this._elDelete.addEventListener('dragover', e => this._deleteDragOverHandler(e));
    this._elDelete.addEventListener('dragleave', e => this._deleteDragLeaveHandler(e));
    this._elDelete.addEventListener('drop', e => this._deleteDropHandler(e));
    /*this._elAdd.addEventListener('click', () => {
      const color = this.currentColor();
      this.addColor(color);
      this.selectColor(color)
    });*/
  }
  static get MAX_COLOR() {return 34;}
  /*selectColor(color) {
    super.selectColor(color);
    this._updateAdd(color);
  }
  _updateAdd(color) {
    if(this._elColorList.querySelector('.selected') || this._elColorList.children.length === ColorPalette.MAX_COLOR) {
      this._elAdd.classList.add('hidden');
    } else {
      this._elAdd.classList.remove('hidden');
      this._elAddInner.style.backgroundColor = `rgba(${color.join()})`;
    }
  }*/
  addColor(color) {
    if(this._elColorList.children.length === ColorPalette.MAX_COLOR) return;
    const rgba = color.join();
    let elColor = this._elColorList.firstElementChild;
    while(elColor) {
      if(elColor.getAttribute('data-rgba') === rgba) {
        return;
      }
      elColor = elColor.nextElementSibling;
    }
    const newColor = this._elTemplateColor.cloneNode(true);
    const inner = newColor.firstElementChild;
    newColor.setAttribute('data-rgba', rgba);
    inner.style.backgroundColor = `rgba(${rgba})`;
    newColor.addEventListener('dragstart', e => this._colorDragStartHandler(e));
    newColor.addEventListener('dragend', e => this._colorDragEndHandler(e));
    newColor.addEventListener('dragover', e => this._colorDragOverHandler(e));
    newColor.addEventListener('drop', e => this._colorDropHandler(e));
    newColor.addEventListener('mouseup', e => this._colorMouseUpHandler(e));
    newColor.addEventListener('dblclick', this._onDblClickColor);
    if(this._colorManager.get().join() === rgba) newColor.classList.add('selected');
    this._elColorList.appendChild(newColor);
    this._updateColorListRepeat();
  }
  _updateColorListRepeat() {
    const {length} = this._elColorList.children;
    const repeat = Math.min(length, 17);
    this._elColorList.style.gridTemplateColumns = `repeat(${repeat},1fr)`;
  }
  _colorDragStartHandler(e) {
    const rgba = e.currentTarget.getAttribute('data-rgba');
    e.dataTransfer.setData('application/my-rgba', rgba);
    e.dataTransfer.effectAllowed = 'move';
    this._elDelete.classList.remove('hidden');
  }
  _colorDragEndHandler(e) {
    this._elDelete.classList.add('hidden');
  }
  _colorDragOverHandler(e) {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  }
  _colorDropHandler(e) {
    e.preventDefault();
    const srcRGBA = e.dataTransfer.getData('application/my-rgba');
    if(srcRGBA) {
      const dst = e.currentTarget;
      const parent = this._elColorList;
      let dstIsFront = false;
      let elColor = parent.firstElementChild;
      while(elColor) {
        const rgba = elColor.getAttribute('data-rgba');
        if(rgba === srcRGBA) {
          if(dstIsFront) {
            parent.insertBefore(elColor, dst);
          } else {
            parent.insertBefore(elColor, dst.nextElementSibling);
          }
          break;
        } else if(elColor === dst) {
          dstIsFront = true;
        }
        elColor = elColor.nextElementSibling;
      }
    }
  }
  _deleteDragOverHandler(e) {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    e.currentTarget.classList.add('dragOver');
  }
  _deleteDragLeaveHandler(e) {
    e.currentTarget.classList.remove('dragOver');
  }
  _deleteDropHandler(e) {
    e.preventDefault();
    const rgba = e.dataTransfer.getData('application/my-rgba');
    if(rgba) {
      const elColor = this._elColorList.querySelector(`.color[data-rgba="${rgba}"]`);
      if(elColor) {
        elColor.remove();
        //this._updateAdd(this.currentColor());
        this._updateColorListRepeat();
      }
    }
    e.currentTarget.classList.remove('dragOver');
  }
  async checkClipboard() {
    const items = await navigator.clipboard.read();
    for(const item of items) {
      for(const type of item.types) {
        if(type.indexOf('image/png') === 0) {
          return await item.getType(type);
        }
      }
    }
    throw 'noimg';
  }
  async paste(blob) {
    const bitmap = await createImageBitmap(blob);
    const {width, height} = bitmap;
    const ctx = new OffscreenCanvas(width, height).getContext('2d');
    ctx.drawImage(bitmap, 0, 0);
    bitmap.close();
    const image = ctx.getImageData(0, 0, width, height);
    
    const arrU32 = new Uint32Array(image.data.buffer);
    const set = new Set;
    for(const u32 of arrU32) set.add(u32);
    for(const v of set) {
      const [r, g, b, a] = new Uint8Array(new Uint32Array([v]).buffer);
      this.addColor([r, g, b, a / 255]);
    }
  }
  clear() {
    let child = this._elColorList.firstElementChild;
    while(child !== null) {
      const next = child.nextElementSibling;
      child.remove();
      child = next;
    }
    this.addColor([0,0,0,0]);
  }
  save() {
    const arrElColor = this._elColorList.querySelectorAll('.color');
    const colors = [...arrElColor].map(elColor => {
      let [r, g, b, a] = elColor.dataset.rgba.split(',').map(parseFloat);
      a = Math.round(a * 255);
      return [r, g, b, a];
    });
    return {colors};
  }
  restore({colors}) {
    this._clear();
    for(const color of colors) {
      this.addColor(this._colorManager.normalize(color));
    }
  }
  _clear() {
    let elColor;
    while(elColor = this._elColorList.firstElementChild) {
      elColor.remove();
    }
  }
}
